import { configureStore, createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit'
import authReducer, { login, loginOrganization, setE2EEFlowStatus } from '../features/auth/authSlice'
import { initE2EEKeys } from 'services/e2ee/keyInit'
import postReducer from '../features/posts/postSlice'
import singlePostReducer from '../features/posts/singlePostSlice'
import singlePostCommentReducer from '../features/comments/singlePostCommentSlice'
import organizationReducer from '../features/organization/organizationSlice'
import profileReducer from '../features/profile/profileSlice'
import profileChurchReducer from '../features/profileChurch/profileChurchSlice'
import commentReducer from '../features/comments/commentSlice'
import mailReducer from '../features/mail/mailSlice'
import searchReducer from '../features/search/searchSlice'
import PassResetReducer from '../features/passwordReset/passResetSlice'
import resetErrorReducer from '../features/error/errorSlice'
import membershipsReducer from '../features/createPost/membershipsSlice' //no longer using this one << ---
import selectPostingToReducer from '../features/createPost/selectPostingToSlice'
import postImageReducer from '../features/createPost/postImageSlice'
import postImagePreviewReducer from '../features/createPost/postImagePreviewSlice'
import selectPostTypeReducer from '../features/createPost/selectPostTypeSlice'
import allowCommentsReducer from '../features/createPost/allowCommentsSlice'
import notificationReducer from '../features/notifs/notifSlice'
import imageReducer from '../features/settings/imageSlice'
import requestReducer from '../features/requests/requestSlice'
import membersReducer from '../features/memberships/membershipSlice'
import messageReducer from '../features/messenger/messengerSlice'
import conversationReducer from '../features/messenger/conversationSlice'
import reportIssueReducer from '../features/reportIssue/reportIssueSlice'
import modalReducer from '../features/modal/modalSlice'
import directoryModalReducer from '../features/modal/directoryModalSlice'
import directorySlice from '../features/directory/directorySlice'
import eventSlice from '../features/events/eventSlice'
import cvSlice from 'features/churchVerification/cvSlice'
import feedbackSlice from 'features/feedback/feedbackSlice'
import pollSlice from 'features/polls/pollSlice'
import bulletinSlice from 'features/bulletin/bulletinSlice'
import announcementSlice from 'features/anouncements/announcementSlice'
import settingSlice from 'features/settings/settingSlice'
import billingSlice from 'features/billing/billingSlice'
import mapSlice from 'features/maps/mapSlice'
import emailSlice from 'features/email/emailSlice'
import sidebarSlice from 'features/sidebar/sidebarSlice'
import marketSlice from 'features/marketplace/marketSlice'
import videoSlice from 'features/videos/videoSlice'
import fileSlice from 'features/files/fileSlice'
import audioSlice from 'features/audio/audioSlice'
import audioPlayerSlice from 'features/audio/audioPlayerSlice'
import givingSlice from 'features/giving/givingSlice'
import givingCampaignSlice from 'features/givingCampaigns/givingCampaignSlice'
import landingPageSlice from 'features/landingPageSlice'
import qaSessionSlice from 'features/qaSessions/qaSessionSlice'
import imagesSlice from 'features/images/imagesSlice'

// ── E2EE listener — runs initE2EEKeys after every successful login ────────────
const e2eeListener = createListenerMiddleware()

const handleLoginSuccess = async (action, listenerApi) => {
  const token  = action.payload?.token
  const userId = action.payload?._id
  if (!token || !userId) return
  try {
    const result = await initE2EEKeys(token, userId)
    if (result.status === 'new_key') {
      listenerApi.dispatch(setE2EEFlowStatus({ status: 'needs_setup', backup: null }))
    } else if (result.status === 'backup_found' && result.backup) {
      listenerApi.dispatch(setE2EEFlowStatus({ status: 'needs_restore', backup: result.backup }))
    }
  } catch (err) {
    console.warn('[E2EE] initE2EEKeys failed:', err)
  }
}

e2eeListener.startListening({
  matcher: isAnyOf(login.fulfilled, loginOrganization.fulfilled),
  effect: handleLoginSuccess,
})

export const store = configureStore({
  reducer: {
    auth: authReducer,
    notifications: notificationReducer,
    profile: profileReducer,
    profileChurch: profileChurchReducer,
    organization: organizationReducer,
    posts: postReducer,
    memberships: membershipsReducer,
    singlePost: singlePostReducer,
    sPComments: singlePostCommentReducer,
    comments: commentReducer,
    mail: mailReducer,
    searchValues: searchReducer,
    isPassResetSuccess: PassResetReducer,
    hasError: resetErrorReducer,
    postingTo: selectPostingToReducer,
    postImage: postImageReducer,
    postImagePreview: postImagePreviewReducer,
    postType: selectPostTypeReducer,
    allowComments: allowCommentsReducer,
    image: imageReducer,
    requests: requestReducer,
    memberships2: membersReducer,
    messages: messageReducer,
    conversations: conversationReducer,
    issues: reportIssueReducer,
    modal: modalReducer,
    directoryModal: directoryModalReducer,
    directory: directorySlice,
    events: eventSlice,
    churchVerification: cvSlice,
    feedback: feedbackSlice,
    poll: pollSlice,
    bulletin: bulletinSlice,
    announcement: announcementSlice,
    settings: settingSlice,
    billing: billingSlice,
    maps: mapSlice,
    email: emailSlice,
    sidebar: sidebarSlice,
    market: marketSlice,
    video: videoSlice,
    audio: audioSlice,
    audioPlayer: audioPlayerSlice,
    file: fileSlice,
    giving: givingSlice,
    givingCampaign: givingCampaignSlice,
    landingPage: landingPageSlice,
    qASession: qaSessionSlice,
    images: imagesSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().prepend(e2eeListener.middleware),
  devTools: process.env.REACT_APP_ENV === 'production' ? false : true
})



//https://www.roc-search.com/job-search/?keyword=software
// i like the way these search results look!!!
